module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-cart js-cart c-cart--slider",
    class: {
      'c-cart--open': _vm.cartOpen
    },
    attrs: {
      "id": "cart-clazz"
    }
  }, [_c('a', {
    staticClass: "c-cart__header",
    attrs: {
      "id": "cart-header",
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCart($event)
      }
    }
  }, [_c('span', {
    staticClass: "c-cart__headerText"
  }, [_vm._v("Shopping Cart")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__headerText"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('ul', {
    staticClass: "c-cart__list"
  }, [_vm._l((_vm.cart), function(ring, index) {
    return _c('li', {
      key: ring.id,
      staticClass: "c-cart__item"
    }, [_c('img', {
      staticClass: "c-cart__image",
      attrs: {
        "src": ring.ring.variations[ring.ring.variationIndex].images[0].url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-cart__item-details c-cart__anim-1"
    }, [_c('h2', {
      staticClass: "c-cart__ringName"
    }, [_vm._v(_vm._s(ring.ring.name))]), _vm._v(" "), _c('p', {
      staticClass: "c-cart__detail"
    }, [_vm._v("Metal: " + _vm._s(ring.ring.variations[ring.ring.variationIndex].variation_name))]), _vm._v(" "), _c('span', {
      staticClass: "c-cart__detail"
    }, [_vm._v("Size: " + _vm._s(ring.selectedSize.text))])]), _vm._v(" "), _c('div', {
      staticClass: "c-cart__item-details c-cart__anim-2 c-cart__item-details--al-m"
    }, [_c('p', {
      staticClass: "c-cart__price"
    }, [_vm._v(_vm._s(ring.ring.variations[ring.ring.variationIndex].price[_vm.$store.state.currency].formatted))]), _vm._v(" "), _c('button', {
      staticClass: "c-cart__link",
      on: {
        "click": function($event) {
          _vm.removeFromCart(index)
        }
      }
    }, [_vm._v("Remove")])])])
  }), _vm._v(" "), _c('p', {
    staticClass: "c-cart__note"
  }, [_vm._v("\n      Please Note:\n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cart.length == 1),
      expression: "cart.length == 1"
    }]
  }, [_vm._v("This item")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cart.length > 1),
      expression: "cart.length > 1"
    }]
  }, [_vm._v("These items")]), _vm._v(" is made to order and will will be dispatched within 4 weeks.\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "c-cart__totals c-cart__anim-basic"
  }, [_c('div', {
    staticClass: "c-cart__subTotal"
  }, [_c('span', {
    staticClass: "c-cart__subTotal-total"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__subTotal-currency"
  }, [_vm._v("(" + _vm._s(_vm.$store.state.currency) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__subTotal-price"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency != 'EUR' && _vm.$store.state.currency != 'GBP'),
      expression: "$store.state.currency != 'EUR' && $store.state.currency != 'GBP'"
    }]
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'EUR'),
      expression: "$store.state.currency == 'EUR'"
    }]
  }, [_vm._v("€")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'GBP'),
      expression: "$store.state.currency == 'GBP'"
    }]
  }, [_vm._v("£")]), _vm._v("\n        " + _vm._s(_vm.total) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-field c-field--checkbox",
    class: {
      'c-field--checkbox-spin': _vm.spinCheckbox
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agreeToTermsError),
      expression: "agreeToTermsError"
    }],
    staticClass: "c-field__error c-field__error--checkout"
  }, [_vm._v("Please accept this term")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeToTerms),
      expression: "agreeToTerms"
    }],
    staticClass: "c-field__input--checkbox",
    attrs: {
      "type": "checkbox",
      "name": "AgreeToTerms",
      "id": "agreeToTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeToTerms) ? _vm._i(_vm.agreeToTerms, null) > -1 : (_vm.agreeToTerms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreeToTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeToTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.agreeToTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreeToTerms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "c-field__label c-field__label--checkbox",
    attrs: {
      "for": "agreeToTerms"
    }
  }, [_vm._v("I accept all terms and conditions")])]), _vm._v(" "), _c('small', {
    staticClass: "c-cart__legals"
  }, [_vm._v("All items are shipped from New Zealand.")]), _vm._v(" "), _c('a', {
    staticClass: "c-cart__checkout c-btn c-btn--block",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.orderItem($event)
      }
    }
  }, [_vm._v("CHECKOUT")]), _vm._v(" "), _c('a', {
    staticClass: "c-btn c-btn__link c-cart__anim-basic",
    staticStyle: {
      "right": "0"
    },
    attrs: {
      "id": "go-back",
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCart($event)
      }
    }
  }, [_vm._v("Continue shopping")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39585818","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 393
// module chunks = 0